// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"HeaderInfo_headerInfo__2-Skw","icon":"HeaderInfo_icon__3vgPU","title":"HeaderInfo_title__1zPZd"};